import { Fragment, useState, useRef } from 'react';
import { wrapIframes } from '../../../services/Util';
import Modal from '../Partials/Modal';

export default function EmailModal({ page }) {
	const [isEmailSent, setIsEmailSent] = useState(false);
	const [email, setEmail] = useState('');
	const [message, setMessage] = useState('');

	const { __ } = wp.i18n;

	const emailInput = useRef();
	const messageInput = useRef();

	const button = page.buttons.find((b) => {
		return 'Email' === b.type;
	});

	if (!button) {
		return;
	}

	if ((!button.value || !button.value.length) && !button.valueIsSet) {
		return false;
	}

	function onEmailUpdate(e) {
		setEmail(e.target.value);
	}

	function onMessageUpdate(e) {
		setMessage(e.target.value);
	}

	function doSendEmail() {
		const { current: emailCurrent } = emailInput;

		if (!email.length) {
			emailCurrent.focus();
			return false;
		}

		const { current: messageCurrent } = messageInput;

		if (!message.length) {
			messageCurrent.focus();
			return false;
		}

		window.jQuery
			.post(window.social_link_pages.admin_ajax, {
				action: 'social_link_pages_send_email',
				email: email,
				message: message,
				page_id: page.id,
				button_id: button.id,
				_wpnonce: document.getElementById('social_link_pages_wpnonce').value,
			})
			.always((response) => {
				setIsEmailSent(true);

				setTimeout(() => {
					setModalOpen(false);
				}, 4000);
			});
	}

	const title =
		button.formTitle && button.formTitle.length > 0
			? button.formTitle
			: __('Send an email', 'social-link-pages');

	return (
		<Modal title={title}>
			{isEmailSent && (
				<div dangerouslySetInnerHTML={{ __html: wrapIframes(button.successMessage) }}></div>
			)}

			{!isEmailSent && (
				<Fragment>
					<p className="form-group mb-3">
						<input
							type="text"
							className="form-control"
							onChange={onEmailUpdate}
							defaultValue={email}
							ref={emailInput}
							autoComplete="off"
							placeholder={
								button.emailInputPlaceholder && button.emailInputPlaceholder.length > 0
									? button.emailInputPlaceholder
									: __('Enter your email address', 'social-link-pages')
							}
						/>
					</p>
					<p className="form-group mb-3">
						<textarea
							className="form-control"
							onChange={onMessageUpdate}
							defaultValue={message}
							ref={messageInput}
							autoComplete="off"
							placeholder={
								button.messageInputPlaceholder && button.messageInputPlaceholder.length > 0
									? button.messageInputPlaceholder
									: __('Question? Comment?', 'social-link-pages')
							}
						/>
					</p>
					<p>
						<button
							className={`btn btn-block ${
								email.length > 0 && message.length > 0 ? '' : 'disabled'
							}`}
							type="button"
							onClick={doSendEmail}
						>
							{button.formSubmitButtonLabel && button.formSubmitButtonLabel.length > 0
								? button.formSubmitButtonLabel
								: __('Send email', 'social-link-pages')}
						</button>
					</p>
				</Fragment>
			)}
		</Modal>
	);
}
